// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"2fe6c06f","64":"9d33e729","204":"14c77fa1","410":"4367b586","444":"9547e390","538":"9dc4d27f","614":"2e5d6e5f","668":"43e9fe83","708":"2c800221","755":"e7993655","799":"2776ad77"}[chunkId] + ".chunk.js";
};